/* Beniya: kleine gedragsuitbreidingen bovenop Dawn (eigen code). */
(function () {
  // Transparante header: hoogte doorgeven en vast maken zodra je scrolt of over de header beweegt.
  function initTransparentHeader() {
    const header = document.querySelector('.section-header');
    if (!header || !document.querySelector('#MainContent > .shopify-section:first-child .bny-transparent-header')) return;
    const wrapper = header.querySelector('.header-wrapper');
    const setHeight = () => document.documentElement.style.setProperty('--bny-header-height', `${wrapper.offsetHeight}px`);
    const update = () => {
      const solid = window.scrollY > 10 || header.matches(':hover') || header.querySelector('details[open]');
      header.classList.toggle('bny-header-solid', Boolean(solid));
    };
    setHeight();
    update();
    new ResizeObserver(setHeight).observe(wrapper);
    window.addEventListener('scroll', update, { passive: true });
    header.addEventListener('mouseenter', update);
    header.addEventListener('mouseleave', () => setTimeout(update, 50));
    header.addEventListener('toggle', update, true);
  }

  // Reveal bij scrollen voor bny-secties.
  function initReveal() {
    const items = document.querySelectorAll('.bny-reveal:not(.is-revealed)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-revealed'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach((el) => io.observe(el));
  }

  // Sticky add-to-cart: verschijnt zodra de echte knop uit beeld is en klikt die knop door.
  function initStickyAtc() {
    const bar = document.querySelector('.bny-sticky-atc');
    if (!bar) return;
    const section = document.getElementById(bar.dataset.section);
    const realButton = section && section.querySelector('.product-form__submit');
    if (!realButton) return;
    const stickyButton = bar.querySelector('button');
    const footer = document.querySelector('.footer');
    let atcVisible = true;
    let footerVisible = false;
    const render = () => bar.classList.toggle('is-visible', !atcVisible && !footerVisible);
    new IntersectionObserver(([e]) => { atcVisible = e.isIntersecting || e.boundingClientRect.top > 0; render(); }).observe(realButton);
    if (footer) new IntersectionObserver(([e]) => { footerVisible = e.isIntersecting; render(); }).observe(footer);
    const sync = () => {
      stickyButton.disabled = realButton.disabled;
      stickyButton.textContent = (realButton.querySelector('span') || realButton).textContent.trim();
    };
    sync();
    new MutationObserver(sync).observe(realButton, { attributes: true, childList: true, subtree: true });
    stickyButton.addEventListener('click', () => realButton.click());
  }

  // Hoogte van de vaste header doorgeven (gebruikt door de scroll-sectie om het beeld te centreren).
  function initStickyHeight() {
    const header = document.querySelector('.section-header.shopify-section-header-sticky');
    if (!header) return;
    const set = () => document.documentElement.style.setProperty('--bny-sticky-height', `${header.offsetHeight}px`);
    set();
    new ResizeObserver(set).observe(header);
  }

  // Stippen onder de productgalerij op mobiel, gekoppeld aan de horizontale scroll.
  function initGalleryDots() {
    document.querySelectorAll("[id^='MainProduct-'] .product__media-wrapper slider-component").forEach((slider) => {
      if (slider.nextElementSibling && slider.nextElementSibling.classList.contains('bny-dots')) return;
      const list = slider.querySelector('.product__media-list');
      const items = list ? Array.from(list.querySelectorAll('.product__media-item')) : [];
      if (items.length < 2) return;
      const dots = document.createElement('div');
      dots.className = 'bny-dots';
      items.forEach((item, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', String(i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.addEventListener('click', () => list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' }));
        dots.appendChild(b);
      });
      slider.after(dots);
      const update = () => {
        const i = Math.round(list.scrollLeft / Math.max(list.clientWidth, 1));
        dots.querySelectorAll('button').forEach((b, n) => b.setAttribute('aria-current', n === i ? 'true' : 'false'));
      };
      list.addEventListener('scroll', update, { passive: true });
    });
  }

  // Aankondigingsbalk: elke berichtwissel start een korte fade-in (de schuifbeweging zelf is via CSS uitgezet).
  function initAnnouncementFade() {
    const slider = document.querySelector('.announcement-bar .slider');
    if (!slider) return;
    let touching = false;
    slider.addEventListener('touchstart', () => { touching = true; }, { passive: true });
    slider.addEventListener('touchend', () => setTimeout(() => { touching = false; }, 400), { passive: true });
    slider.addEventListener('scroll', () => {
      if (touching) return;
      slider.classList.remove('bny-fade');
      void slider.offsetWidth;
      slider.classList.add('bny-fade');
    }, { passive: true });
  }

  function init() {
    initAnnouncementFade();
    initGalleryDots();
    initStickyHeight();
    initTransparentHeader();
    initReveal();
    initStickyAtc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', initReveal);
})();
